import { Carousel } from "antd";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import HomeSection from "../../common/HomeSection";
import ServiceCard from "../../components/Homepage/ServiceCard/ServiceCard";
import VeichelTypeCard from "../../components/Homepage/VeichelTypeCard/VeichelTypeCard";
import WelcomePopup from "../../components/WelcomePopup/WelcomePopup";
import FormsSection from "./FormsSection";
import "./Home.css";

/**
 * The main entry point of the Home page
 *
 * @returns {JSX.Element}
 */

const Home = () => {
  const [t] = useTranslation("global");

  const servicesData = useSelector(
    (state) => state.cachedRequests.servicesRequest
  );

  const vehicleTypeData = useSelector(
    (state) => state.cachedRequests.vehiclesRequest
  );

  return (
    <div>
      <WelcomePopup
        title={t("popup.title")}
        message={t("popup.message")}
        buttonText={t("popup.buttonText")}
      />
      <FormsSection />
      {servicesData?.length > 0 && (
        <HomeSection title={t("services.heading")} id="services">
          <div className="grid md:grid-cols-3 grid-cols-1 gap-4 mx-2">
            {servicesData?.map((service) => (
              <ServiceCard
                key={service.id}
                title={service.service_name}
                description={service.service_desc}
                img={service.icon}
                alt={service.id}
              />
            ))}
          </div>
        </HomeSection>
      )}
      {vehicleTypeData?.message && (
        <HomeSection title={t("vehicle_type.heading")} id="vehicleType">
          <Carousel
            arrows={true}
            dots={false}
            slidesToShow={3}
            draggable
            infinite
            lazyLoad
            responsive={[
              {
                breakpoint: 1024,
                settings: {
                  slidesToShow: 2,
                },
              },
              {
                breakpoint: 768,
                settings: {
                  slidesToShow: 1,
                },
              },
            ]}
          >
            {vehicleTypeData?.message?.map((veichelType, idx) => (
              <VeichelTypeCard
                key={`${veichelType.id}-${idx}`}
                veichel={veichelType}
              />
            ))}
          </Carousel>
        </HomeSection>
      )}
    </div>
  );
};

export default Home;
